import { render, staticRenderFns } from "./service1.vue?vue&type=template&id=478f23aa&scoped=true"
import script from "./service1.vue?vue&type=script&lang=js"
export * from "./service1.vue?vue&type=script&lang=js"
import style0 from "./service1.vue?vue&type=style&index=0&id=478f23aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f23aa",
  null
  
)

export default component.exports